<template>
  <div class="media-wrapper" @click="onClickMedia">
    <div class="media-thumbnail" v-if="isThumbnailShow">
      <img class="full-width" :src="thumbnailSource">
      <div class="media-info-wrapper"> 
        <div class="media-info-text">
          {{data.name}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import theme from '@/mixins/theme.js'
import media from '@/mixins/media.js'
import timeFormatter from '@/utils/timeFormatter.js'

import axios from "axios";
import mime from 'mime-types'

export default {
  name: "MediaThumbnail",
  mixins: [media],
  components: {
  },
  props: {
    media: Object,
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.media)),
    }
  },
  computed: {
    
    // Helper
    time() {
      return timeFormatter(this.data.duration);
    },
  },
  watch: {
  },
  created() {
    
  },
  methods: {
    onClickMedia() {
      this.$router.push({
        name: 'Media',
        params: {
          mediaId: this.media._id
        }
      });
    },
    
  }
};
</script>

<style scoped>
.media-wrapper {
  pointer-events: auto;
  cursor: pointer;
  color: white;
}
.media-wrapper:hover {
  opacity: 0.75;
  cursor: pointer;
}
.media-info-wrapper {
  position: absolute;
  top: 0px;
  left: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.5);
}
.media-info-text {
  padding: 4px;
}
</style>